export default "__VITE_ASSET__BMGNZAY5__"